// extracted by mini-css-extract-plugin
module.exports = {"StepWrapper":"Steps_StepWrapper__2Qe4P","StepIcon":"Steps_StepIcon__2xBy3"};